var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",style:(`background-color:${_vm.bgColor};`)},[_c('div',{staticClass:"inner",style:(`color:${_vm.color};`)},[_vm._v(_vm._s(_vm.rank))])])
}
var staticRenderFns = []

export { render, staticRenderFns }